import React, {useEffect} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {TextField, FormHelperText} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import Navigation from '../../../assets/images/Navigation.png';
import {postforgotPassword, resetMsg, resetStatus} from '../../../redux/reducers/forgotPassword';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {Link} from 'react-router-dom';

const ForgotPassword = () => {
  const schema = Yup.object().shape({
    email: Yup.string().email('Invalid email format').required('Please enter the email'),
  });

  const dispatch = useDispatch();
  const {isLoading, errorMsg, successMsg} = useSelector(({forgotPassword}) => forgotPassword);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetStatus());
        dispatch(resetMsg());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  const handleSubmit = (values) => {
    dispatch(postforgotPassword(values.email));
  };

  const initialValue = {
    email: '',
  };

  return (
    <div className="App">
      <div className="login-page">
        <div className="main-content">
          <div className="company-logo">
            <img src={Navigation} alt="navigation-logo" />
          </div>
          <div className="form-content">
            <h4 role="heading" aria-level="1">
              Forgot Password
            </h4>
            <p>Enter the email address associated with your accounts</p>
            <Formik
              onSubmit={(values) => handleSubmit(values)}
              validationSchema={schema}
              initialValues={initialValue}
              enableReinitialize
            >
              {(props) => {
                const {
                  values,
                  handleChange,
                  handleSubmit,
                  handleReset,
                  handleBlur,
                  touched,
                  errors,
                } = props;
                return (
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="form-group reset-password-fields">
                      <label>EMAIL</label>
                      <TextField
                        // className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        // placeholder="Enter Email"
                        // label="Email"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.email}
                        error={Boolean(touched.email && errors.email)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.email && errors.email && errors.email}
                      </FormHelperText>
                    </div>
                    <button type="submit" className="login-btn btn-block">
                      SUBMIT
                    </button>
                  </form>
                );
              }}
            </Formik>
            <div className="forgot-pw mt-3">
              Remember your password?
              <Link to={{pathname: `/login`}}> Back to login</Link>
            </div>
          </div>
          {isLoading && <PageLoader />}
          {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
        </div>
        <div className="copyright">
          <p style={{color: '#000'}}>&copy;2021 PDS Galaxy</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
